// What the person is looking at, sent with each chat message so the agent can
// see it too. The content pane and any open side panel carry
// `data-agent-view`; their visible text is what the person sees, whatever the
// page. The agent card itself sits outside them, so it never reads itself.
// See backend/src/agents/page.py for what the brief does with it.

export interface PageSnapshot {
    path: string;
    title: string;
    text: string;
}

// Enough for a page's worth of reading; the brief trims it again.
const TEXT_CAP = 12_000;

export function capturePage(): PageSnapshot {
    const text = Array.from(document.querySelectorAll<HTMLElement>('[data-agent-view]'))
        .map(el => el.innerText)
        .join('\n\n')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    return {
        path: window.location.pathname + window.location.search,
        title: document.title,
        text: text.length > TEXT_CAP ? text.slice(0, TEXT_CAP) : text,
    };
}
